export const FREQUENCY_MODE = {
    NONE: 'NONE',
    CUSTOM: 'CUSTOM',
};
